import { render, staticRenderFns } from "./im-friends.vue?vue&type=template&id=2a914e70&scoped=true"
import script from "./im-friends.vue?vue&type=script&lang=js"
export * from "./im-friends.vue?vue&type=script&lang=js"
import style0 from "./im-friends.vue?vue&type=style&index=0&id=2a914e70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a914e70",
  null
  
)

export default component.exports